import React from "react";
import { CardHeader } from "../../../../../components/cards";
import { StockGraph } from "../../../../scans/components/graphs";
import { Loading } from "../../../../../components";

interface IProductStockVariations {
  data: any;
  loading: boolean;
}

export const ProductStock: React.FC<IProductStockVariations> = ({
  data,
  loading,
}) => {
  return (
    <>
      {loading ? <Loading /> : null}
      {data ? <StockGraph data={data} /> : null}
    </>
  );
};
